// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"172":"4d7ed49c","196":"fd185f38","234":"3e1a91cc","268":"e80fc144","437":"55e30b39","471":"218f195b","484":"8c798445","530":"cac07f89"}[chunkId] + ".js";
};